import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-75081866"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "file-info"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "file-name"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-xiazai"
}, null, -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "5px"
  }
}, "下载", -1));

const _hoisted_6 = [_hoisted_4, _hoisted_5];
export default {
  props: {
    fileInfo: Object,
    isReadonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['deleteFile'],

  setup(__props, {
    emit
  }) {
    const $utils = inject('$utils'); // const groupId = inject('groupId')

    const handlePreview = file => {
      window.open(`/preview.html?id=${file.fileId}&type=4`, '_blank');
    };

    const handleDownload = file => {
      window.location.href = file.fileUrl;
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "file-list",
        onClick: _cache[1] || (_cache[1] = $event => handlePreview(__props.fileInfo))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        src: require(`assets/images/types_icon/${_unref($utils).formatIcons(__props.fileInfo.suffix)}.png`),
        alt: "",
        class: "file-icon"
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, _toDisplayString(__props.fileInfo.fileName), 1)]), !__props.isReadonly ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "file-btn",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleDownload(__props.fileInfo), ["stop"]))
      }, _hoisted_6)) : _createCommentVNode("", true)]);
    };
  }

};